module.exports = __webpack_public_path__ + "img/sys_2.6ddda2f9.png";